/* assets/gproperty-page.js — GPROPERTY ADDRESS / ROUTE RUNTIME
 * Public /pages/gproperty runtime for GP-03 Address Composer, GP-04 Address Results,
 * GP-05 Address State / feedback, verified local drafts and route gating.
 * API transport remains owned by assets/gproperty-public-gateway.js.
 * Draft/data normalization remains owned by assets/gproperty-flow-context.js.
 * No analysis POST is made from this file (Fail Closed by design).
 */
(function (window, document) {
  'use strict';

  var ROOT = '[data-gproperty-page]';
  var VERSION = 'gproperty-address-composer-03';
  var RESULTS_CONTRACT = 'gproperty-address-results-04';
  var STATE_CONTRACT = 'gproperty-address-state-05';
  var SEARCH_DELAY_MS = 360;
  var ALLOWED_SOURCES = {
    glhk: true,
    gproperty: true,
    'gproperty-assets': true,
    gcitymap: true,
  };
  var ALLOWED_INTENTS = {
    'property-analysis': true,
    family: true,
    buyer: true,
    owner: true,
    'family-fit': true,
    'owner-fit': true,
    'buyer-evidence': true,
    'evidence-readiness': true,
  };

  function all(root, selector) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function setText(root, selector, value) {
    var node = root.querySelector(selector);
    if (node) node.textContent = value;
  }

  function setReadiness(root, state, title, copy, badge) {
    var panel = root.querySelector('[data-gproperty-readiness]');
    if (panel) panel.setAttribute('data-state', state);
    root.setAttribute('data-readiness-state', state);
    setText(root, '[data-gproperty-readiness-title]', title);
    setText(root, '[data-gproperty-readiness-copy]', copy);
    setText(root, '[data-gproperty-readiness-badge]', badge);
  }

  function normalizeParam(value, allowlist, fallback) {
    var text = String(value || '')
      .trim()
      .toLowerCase();
    return allowlist[text] ? text : fallback;
  }

  function entryContext() {
    var params = new URLSearchParams(window.location.search || '');
    return {
      source: normalizeParam(params.get('source'), ALLOWED_SOURCES, 'gproperty'),
      intent: normalizeParam(params.get('intent'), ALLOWED_INTENTS, 'property-analysis'),
    };
  }

  function primaryRouteKind(intent) {
    if (intent === 'family' || intent === 'family-fit') return 'family';
    if (intent === 'owner' || intent === 'owner-fit') return 'owner';
    return 'assets';
  }

  function routeIntent(kind, entryIntent) {
    if (kind === 'family' || kind === 'school') return 'family-fit';
    if (kind === 'owner') return 'owner-fit';
    return entryIntent === 'buyer' || entryIntent === 'buyer-evidence'
      ? 'buyer-evidence'
      : 'evidence-readiness';
  }

  function composerLocale(root) {
    var review = root.querySelector('[data-gproperty-review]');
    var locale = String((review && review.getAttribute('data-gproperty-composer-locale')) || '')
      .trim()
      .toLowerCase();

    if (locale === 'zh-cn' || locale === 'zh-hans' || locale === 'zh-sg') {
      return 'zh-Hans';
    }

    if (locale === 'zh-hk' || locale === 'zh-tw' || locale === 'zh-hant') {
      return 'zh-Hant';
    }

    return 'en';
  }

  function entryCopy(locale, intent) {
    var familyIntent = intent === 'family' || intent === 'family-fit';
    var ownerIntent = intent === 'owner' || intent === 'owner-fit';
    var evidenceIntent =
      intent === 'buyer' || intent === 'buyer-evidence' || intent === 'evidence-readiness';

    if (locale === 'zh-Hans') {
      if (familyIntent)
        return [
          '先确认地址，再看家庭日常',
          '搜索并选择正确的香港地址后，再查看学校、交通和家庭生活配套。',
        ];
      if (ownerIntent)
        return [
          '先确认地址，再整理物业情况',
          '搜索并选择正确的香港地址后，再整理业主资料和下一步。',
        ];
      if (evidenceIntent)
        return [
          '先确认地址，再整理已有资料',
          '搜索并选择正确的香港地址后，再查看已有、缺少和需要核实的资料。',
        ];
      return ['先确认地址，再看下一步', '搜索香港屋苑、大厦或门牌地址，选择正确匹配后再继续。'];
    }

    if (locale === 'zh-Hant') {
      if (familyIntent)
        return [
          '先確認地址，再看家庭日常',
          '搜尋並選擇正確的香港地址後，再查看學校、交通和家庭生活配套。',
        ];
      if (ownerIntent)
        return [
          '先確認地址，再整理物業情況',
          '搜尋並選擇正確的香港地址後，再整理業主資料和下一步。',
        ];
      if (evidenceIntent)
        return [
          '先確認地址，再整理已有資料',
          '搜尋並選擇正確的香港地址後，再查看已有、缺少和需要核實的資料。',
        ];
      return ['先確認地址，再看下一步', '搜尋香港屋苑、大廈或門牌地址，選擇正確匹配後再繼續。'];
    }

    if (familyIntent)
      return [
        'Check the address, then review family life',
        'Choose the correct Hong Kong address before reviewing schools, transport and everyday family amenities.',
      ];
    if (ownerIntent)
      return [
        'Check the address, then organise the property',
        'Choose the correct Hong Kong address before organising owner information and next steps.',
      ];
    if (evidenceIntent)
      return [
        'Check the address, then organise the evidence',
        'Choose the correct Hong Kong address before reviewing what you have, what is missing and what needs checking.',
      ];
    return [
      'Check the address first',
      'Search a Hong Kong estate, building or street address and choose the correct match before continuing.',
    ];
  }

  function resultCopy(locale) {
    if (locale === 'zh-Hans') {
      return {
        loadingTitle: '正在核实公开地址',
        loadingCopy: '正在查询香港地址资料，并只显示符合当前核实规则的结果。',
        emptyTitle: '未找到可核实地址',
        emptyCopy: '请尝试屋苑、大厦名称或更完整的门牌地址。',
        fallbackTitle: '找到地点，但暂未通过地址核实',
        fallbackCopy:
          '系统找到参考位置，但暂时没有符合当前核实规则的地址。请使用更具体的香港地址重试。',
        timeoutTitle: '地址服务响应超时',
        timeoutCopy: '没有使用替代或伪造结果。请稍后重试，或先保存本地文字草稿。',
        unavailableTitle: '地址服务暂时不可用',
        unavailableCopy: '没有使用替代或伪造结果。请稍后重试，或先保存本地文字草稿。',
        verifiedAddress: '已核实地址',
        addressUnavailable: '未提供具体门牌地址',
        coordinateVerified: '坐标已核实',
        coordinateUnavailable: '未提供核实坐标',
        sourceVerified: '政府地址资料',
        sourceUnknown: '公开地址来源',
        selectedStatus: '已选择可核实地址，可继续保存。',
        chooseAnother: '重新选择',
        resultsFound: function (count) {
          return '找到 ' + count + ' 项可核实地址。可用上下方向键浏览，按 Enter 选择。';
        },
      };
    }

    if (locale === 'zh-Hant') {
      return {
        loadingTitle: '正在核實公開地址',
        loadingCopy: '正在查詢香港地址資料，並只顯示符合目前核實規則的結果。',
        emptyTitle: '未找到可核實地址',
        emptyCopy: '請嘗試屋苑、大廈名稱或更完整的門牌地址。',
        fallbackTitle: '找到地點，但暫未通過地址核實',
        fallbackCopy:
          '系統找到參考位置，但暫時沒有符合目前核實規則的地址。請使用更具體的香港地址重試。',
        timeoutTitle: '地址服務回應逾時',
        timeoutCopy: '沒有使用替代或偽造結果。請稍後重試，或先儲存本地文字草稿。',
        unavailableTitle: '地址服務暫時不可用',
        unavailableCopy: '沒有使用替代或偽造結果。請稍後重試，或先儲存本地文字草稿。',
        verifiedAddress: '已核實地址',
        addressUnavailable: '未提供具體門牌地址',
        coordinateVerified: '座標已核實',
        coordinateUnavailable: '未提供核實座標',
        sourceVerified: '政府地址資料',
        sourceUnknown: '公開地址來源',
        selectedStatus: '已選擇可核實地址，可繼續儲存。',
        chooseAnother: '重新選擇',
        resultsFound: function (count) {
          return '找到 ' + count + ' 項可核實地址。可用上下方向鍵瀏覽，按 Enter 選擇。';
        },
      };
    }

    return {
      loadingTitle: 'Checking public address data',
      loadingCopy:
        'Searching Hong Kong address data and showing only results that meet the current verification policy.',
      emptyTitle: 'No verifiable address found',
      emptyCopy: 'Try an estate, building name or a more complete street address.',
      fallbackTitle: 'Place found, but address verification is not available',
      fallbackCopy:
        'A reference location was found, but no address currently meets the verification checks. Try a more specific Hong Kong address.',
      timeoutTitle: 'Address service timed out',
      timeoutCopy:
        'No fallback or fabricated result was substituted. Try again later, or save a local text draft.',
      unavailableTitle: 'Address service is temporarily unavailable',
      unavailableCopy:
        'No fallback or fabricated result was substituted. Try again later, or save a local text draft.',
      verifiedAddress: 'Verified address',
      addressUnavailable: 'Street address not provided',
      coordinateVerified: 'Coordinates verified',
      coordinateUnavailable: 'Verified coordinates not provided',
      sourceVerified: 'Government address data',
      sourceUnknown: 'Public address source',
      selectedStatus: 'Verified address selected. You can continue to save it.',
      chooseAnother: 'Choose another',
      resultsFound: function (count) {
        return (
          count +
          ' verifiable address' +
          (count === 1 ? '' : 'es') +
          ' found. Use the arrow keys to browse and Enter to choose.'
        );
      },
    };
  }

  function stateCopy(locale) {
    if (locale === 'zh-Hans') {
      return {
        checkingTitle: '正在检查后续公开资料状态',
        checkingCopy: '地址核实与后续公开资料就绪状态分开检查；地址搜索不会等待分析资料加载。',
        checkingBadge: '检查中',
        readyTitle: '后续公开资料已就绪',
        readyCopy: '所需公开资料已准备好；已核实地址可继续家庭、业主和学校相关流程。',
        readyBadge: '可继续',
        blockedTitle: '地址可核实，后续资料暂未就绪',
        blockedCopy:
          '你仍可搜索并保存地址；家庭、业主和学校相关流程要等所需公开资料准备好后才可继续。',
        blockedBadge: '暂未开放',
        unavailableTitle: '暂时无法确认后续公开资料状态',
        unavailableCopy:
          '地址搜索仍可使用；在资料状态未确认前，后续流程不会开放，也不会假设资料可用。',
        unavailableBadge: '未确认',
        retry: '重新搜索',
        shortQuery: '请再输入至少一个字。',
        needQuery: '请先输入地址关键字。',
        needVerified: '请先选择一项可核实地址，再保存为已核实地址。',
        storageError: '当前浏览器无法写入本地地址草稿。',
        savedVerifiedStatus: '已在此浏览器保存已核实地址。',
        savedDraftStatus: '已在此浏览器保存文字草稿；需要核实地址的流程仍保持关闭。',
        resetStatus:
          '已重置当前地址选择。之前保存的本地草稿仍保留在此浏览器，重新载入页面时可恢复。',
        migratedStatus: '已更新旧版本本地草稿。',
        routeReady: '地址已核实，后续公开资料也已准备好。继续时不会在链接中加入完整地址。',
        routeWaiting:
          '地址已核实，但家庭／业主／学校流程仍等待所需公开资料准备好；资料准备入口仍可使用。',
        routeDraft:
          '这是未核实的本地文字草稿。资料准备入口仍可使用；家庭／业主／学校流程保持关闭。',
        blockedVerified: '此入口需要先选择并保存已核实地址。',
        blockedReadiness: '地址已核实，但后续所需公开资料尚未准备好。',
        savedVerifiedTitle: '已核实地址已保存在此设备',
        savedVerifiedCopy:
          '本地草稿保留已核实地址的来源与核验信息；后续流程仍会再次检查当前公开资料就绪状态。',
        savedDraftTitle: '本地地址草稿已保存',
        savedDraftCopy:
          '这份文字草稿只保存在当前浏览器，不能开启需要已核实地址的家庭、业主或学校流程。',
        restoredPrefix: '已从此浏览器恢复。',
        verifiedLabel: '已核实 · 政府地址资料',
        draftLabel: '未核实 · 仅本地文字',
        privacyTitle: '地址草稿与私隐',
        privacyItems: [
          '此地址检查不会要求输入姓名、电话或个人电邮。',
          '本页的地址草稿保存在当前浏览器。',
          '继续到其他 GProperty 功能时，会按对应功能说明的资料用途处理。',
          '此处不会生成正式估价、测量或法律结论。',
        ],
        sourceTitle: '已核实地址来源',
        sourceCopy:
          '只有符合当前地址核实规则的政府地址结果可标记为已核实；其他参考位置不会显示为已核实地址。',
        saveDraftAction: '保存本地草稿',
        saveVerifiedAction: '保存已核实地址',
      };
    }

    if (locale === 'zh-Hant') {
      return {
        checkingTitle: '正在檢查後續公開資料狀態',
        checkingCopy: '地址核實與後續公開資料就緒狀態分開檢查；地址搜尋不會等待分析資料載入。',
        checkingBadge: '檢查中',
        readyTitle: '後續公開資料已就緒',
        readyCopy: '所需公開資料已準備好；已核實地址可繼續家庭、業主和學校相關流程。',
        readyBadge: '可繼續',
        blockedTitle: '地址可核實，後續資料暫未就緒',
        blockedCopy:
          '你仍可搜尋並儲存地址；家庭、業主和學校相關流程要等所需公開資料準備好後才可繼續。',
        blockedBadge: '暫未開放',
        unavailableTitle: '暫時無法確認後續公開資料狀態',
        unavailableCopy:
          '地址搜尋仍可使用；在資料狀態未確認前，後續流程不會開放，也不會假設資料可用。',
        unavailableBadge: '未確認',
        retry: '重新搜尋',
        shortQuery: '請再輸入至少一個字。',
        needQuery: '請先輸入地址關鍵字。',
        needVerified: '請先選擇一項可核實地址，再儲存為已核實地址。',
        storageError: '目前瀏覽器無法寫入本地地址草稿。',
        savedVerifiedStatus: '已在此瀏覽器儲存已核實地址。',
        savedDraftStatus: '已在此瀏覽器儲存文字草稿；需要核實地址的流程仍保持關閉。',
        resetStatus:
          '已重設目前地址選擇。之前儲存的本地草稿仍保留在此瀏覽器，重新載入頁面時可恢復。',
        migratedStatus: '已更新舊版本本地草稿。',
        routeReady: '地址已核實，後續公開資料也已準備好。繼續時不會在連結中加入完整地址。',
        routeWaiting:
          '地址已核實，但家庭／業主／學校流程仍等待所需公開資料準備好；資料準備入口仍可使用。',
        routeDraft:
          '這是未核實的本地文字草稿。資料準備入口仍可使用；家庭／業主／學校流程保持關閉。',
        blockedVerified: '此入口需要先選擇並儲存已核實地址。',
        blockedReadiness: '地址已核實，但後續所需公開資料尚未準備好。',
        savedVerifiedTitle: '已核實地址已儲存在此裝置',
        savedVerifiedCopy:
          '本地草稿保留已核實地址的來源與核驗資料；後續流程仍會再次檢查目前公開資料就緒狀態。',
        savedDraftTitle: '本地地址草稿已儲存',
        savedDraftCopy:
          '這份文字草稿只保存在目前瀏覽器，不能開啟需要已核實地址的家庭、業主或學校流程。',
        restoredPrefix: '已從此瀏覽器恢復。',
        verifiedLabel: '已核實 · 政府地址資料',
        draftLabel: '未核實 · 僅本地文字',
        privacyTitle: '地址草稿與私隱',
        privacyItems: [
          '此地址檢查不會要求輸入姓名、電話或個人電郵。',
          '本頁的地址草稿保存在目前瀏覽器。',
          '繼續到其他 GProperty 功能時，會按對應功能說明的資料用途處理。',
          '此處不會生成正式估價、測量或法律結論。',
        ],
        sourceTitle: '已核實地址來源',
        sourceCopy:
          '只有符合目前地址核實規則的政府地址結果可標記為已核實；其他參考位置不會顯示為已核實地址。',
        saveDraftAction: '儲存本地草稿',
        saveVerifiedAction: '儲存已核實地址',
      };
    }

    return {
      checkingTitle: 'Checking follow-on public-data availability',
      checkingCopy:
        'Address verification and follow-on data readiness are checked separately; address search does not wait for analysis data.',
      checkingBadge: 'Checking',
      readyTitle: 'Follow-on public data is ready',
      readyCopy:
        'The required public information is ready. A verified address can continue to Family, Owner and School workflows.',
      readyBadge: 'Ready',
      blockedTitle: 'Address verification is available; follow-on data is not ready',
      blockedCopy:
        'You can still search and save an address. Family, Owner and School workflows will remain closed until the required public information is ready.',
      blockedBadge: 'Not ready',
      unavailableTitle: 'Follow-on public-data readiness could not be confirmed',
      unavailableCopy:
        'Address search remains available. Follow-on workflows stay closed until the data status can be confirmed; no substitute ready state is assumed.',
      unavailableBadge: 'Unconfirmed',
      retry: 'Retry search',
      shortQuery: 'Enter at least one more character.',
      needQuery: 'Enter an address first.',
      needVerified: 'Choose a verifiable address before saving it as verified.',
      storageError: 'This browser could not save the local address draft.',
      savedVerifiedStatus: 'Verified address saved in this browser.',
      savedDraftStatus:
        'Local text draft saved in this browser; verified-address workflows remain closed.',
      resetStatus:
        'Current address selection reset. The previously saved local draft remains in this browser and can be restored after reload.',
      migratedStatus: 'An older local draft has been updated.',
      routeReady:
        'The address is verified and the required public information is ready. Continuing will not place the full address in the link.',
      routeWaiting:
        'The address is verified, but Family, Owner and School workflows are waiting for the required public information to be ready. Evidence readiness remains available.',
      routeDraft:
        'This is an unverified local text draft. Evidence readiness remains available; Family, Owner and School workflows stay closed.',
      blockedVerified: 'Verify and save an address before using this workflow.',
      blockedReadiness:
        'The address is verified, but the required follow-on public information is not ready yet.',
      savedVerifiedTitle: 'Verified address saved on this device',
      savedVerifiedCopy:
        'The local draft keeps the verified address provenance. Follow-on workflows still re-check current public-data readiness.',
      savedDraftTitle: 'Local address draft saved',
      savedDraftCopy:
        'This text draft stays in the current browser and cannot unlock Family, Owner or School workflows that require a verified address.',
      restoredPrefix: 'Restored from this browser. ',
      verifiedLabel: 'Verified · government address data',
      draftLabel: 'Unverified · local text only',
      privacyTitle: 'Address draft and privacy',
      privacyItems: [
        'This address check does not ask for your name, phone number or personal email.',
        'The address draft on this page is stored in the current browser.',
        'Other GProperty features apply their own data-use notice when you continue.',
        'No formal valuation, survey or legal conclusion is created here.',
      ],
      sourceTitle: 'Verified address source',
      sourceCopy:
        'Only government address results that meet the current verification checks can be marked verified; reference-only locations are not presented as verified.',
      saveDraftAction: 'Save local draft',
      saveVerifiedAction: 'Save verified address',
    };
  }

  function applyEntryCopy(root, context) {
    if (root.classList.contains('gproperty-page--free-tools')) return;
    var copy = entryCopy(composerLocale(root), context.intent);
    setText(root, '[data-gproperty-entry-title]', copy[0]);
    setText(root, '[data-gproperty-entry-lead]', copy[1]);
  }

  function applyStateStaticCopy(root, copy) {
    const privacy = root.querySelector('[data-gproperty-privacy-note]');
    const source = root.querySelector('[data-gproperty-source-note]');
    let privacyItems;
    const saved = root.querySelector('[data-gproperty-saved]');

    if (privacy) {
      var privacyTitle = privacy.querySelector('h2');
      if (privacyTitle) privacyTitle.textContent = copy.privacyTitle;
      privacyItems = all(privacy, 'li');
      copy.privacyItems.forEach(function (item, index) {
        if (privacyItems[index]) privacyItems[index].textContent = item;
      });
    }

    if (source) {
      var sourceTitle = source.querySelector('h2');
      var sourceCopy = source.querySelector('p:last-child');
      if (sourceTitle) sourceTitle.textContent = copy.sourceTitle;
      if (sourceCopy) sourceCopy.textContent = copy.sourceCopy;
    }

    setText(root, '[data-gproperty-save-unverified]', copy.saveDraftAction);
    setText(root, '[data-gproperty-save-verified]', copy.saveVerifiedAction);
    if (saved) saved.setAttribute('data-address-state-contract', STATE_CONTRACT);
  }

  /* GP-04 dynamic affordance uses text, not a second SVG/icon owner. */
  function makeResultArrowIcon() {
    var span = document.createElement('span');
    span.className = 'gproperty-page__result-arrow';
    span.setAttribute('aria-hidden', 'true');
    span.textContent = '›';
    return span;
  }

  function focusAddressWorkspace(root, selectText) {
    if (!(root instanceof HTMLElement)) return;

    const query = root.querySelector('[data-gproperty-query]');
    const review = root.querySelector('[data-gproperty-review]');
    if (!query) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (review) {
      review.scrollIntoView({
        behavior: reducedMotion ? 'auto' : 'smooth',
        block: 'start',
      });
    }

    window.setTimeout(
      function () {
        if (!document.contains(query) || query.disabled) return;

        try {
          query.focus({ preventScroll: true });
        } catch (_) {
          query.focus();
        }

        if (selectText && typeof query.select === 'function') {
          query.select();
        }
      },
      reducedMotion ? 0 : 220
    );
  }

  /* GP-03: One route-scoped Command-K shortcut, matching the visible ⌘K label.
   * Runs in capture phase before the global Search shortcut. A single document
   * listener survives Shopify section reloads and only acts on a live GP root.
   * It never handles other routes, editable fields, modal dialogs or disabled UI. */
  function bindCommandK() {
    if (window.__GPROPERTY_ADDRESS_COMMAND_K_OWNER__ === VERSION) return;
    window.__GPROPERTY_ADDRESS_COMMAND_K_OWNER__ = VERSION;
    document.addEventListener(
      'keydown',
      function (event) {
        if (
          event.defaultPrevented ||
          event.altKey ||
          event.shiftKey ||
          !(event.metaKey || event.ctrlKey) ||
          String(event.key || '').toLowerCase() !== 'k'
        )
          return;
        var activeRoot = document.querySelector(ROOT);
        if (!activeRoot || activeRoot.getAttribute('data-runtime-version') !== VERSION) return;
        var input = activeRoot.querySelector('[data-gproperty-query]');
        if (!input || input.disabled || !document.contains(input)) return;
        var active = document.activeElement;
        if (
          active &&
          (active.isContentEditable ||
            /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName) ||
            active.closest('[contenteditable="true"]'))
        )
          return;
        if (document.querySelector('dialog[open], [aria-modal="true"]:not([hidden])')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        focusAddressWorkspace(activeRoot, false);
      },
      true
    );
  }

  /** @param {HTMLElement} root */
  function init(root) {
    if (!root || root.getAttribute('data-runtime-version') === VERSION) return;
    root.setAttribute('data-runtime-version', VERSION);
    root.setAttribute('data-address-results-contract', RESULTS_CONTRACT);
    root.setAttribute('data-address-state-contract', STATE_CONTRACT);

    var gate = window.GPROPERTY_DATA_GATE;
    if (!gate) return;

    var context = entryContext();
    var locale = composerLocale(root);
    var resultText = resultCopy(locale);
    var stateText = stateCopy(locale);
    root.dataset.entrySource = context.source;
    root.dataset.entryIntent = context.intent;
    applyEntryCopy(root, context);
    applyStateStaticCopy(root, stateText);

    var form = root.querySelector('[data-gproperty-form]');
    var query = root.querySelector('[data-gproperty-query]');
    var review = root.querySelector('[data-gproperty-review]');
    var startReview = root.querySelector('[data-gproperty-start-review]');
    var results = root.querySelector('[data-gproperty-results]');
    var spinner = root.querySelector('[data-gproperty-search-spinner]');
    var searchSubmit = root.querySelector('[data-gproperty-search-submit]');
    var clearQuery = root.querySelector('[data-gproperty-clear-query]');
    var saveVerified = root.querySelector('[data-gproperty-save-verified]');
    var saveUnverified = root.querySelector('[data-gproperty-save-unverified]');
    var clearSelection = root.querySelector('[data-gproperty-clear-selection]');
    var selection = root.querySelector('[data-gproperty-selection]');
    var statusNode = root.querySelector('[data-gproperty-status]');
    var savedPanel = root.querySelector('[data-gproperty-saved]');
    var savedRecord = root.querySelector('[data-gproperty-saved-record]');
    var selected = null;
    var activeDraft = null;
    var servingReady = false;
    var timer = 0;
    var requestSequence = 0;
    var key = root.getAttribute('data-local-draft-key') || gate.canonicalDraftKey;
    var legacyKey = root.getAttribute('data-legacy-draft-key') || gate.legacyDraftKey;

    if (savedRecord) {
      var savedRecordFact = savedRecord.closest('div');
      if (savedRecordFact && !savedRecord.closest('details')) savedRecordFact.hidden = true;
    }

    root.dataset.servingReady = 'false';
    setReadiness(
      root,
      'checking',
      stateText.checkingTitle,
      stateText.checkingCopy,
      stateText.checkingBadge
    );
    setAddressState('empty');

    if (query) {
      query.setAttribute('role', 'combobox');
      query.setAttribute('aria-haspopup', 'listbox');
    }
    bindCommandK();
    if (statusNode) statusNode.setAttribute('data-gproperty-verification-toast', '');
    if (selection) {
      var selectionEyebrow = selection.querySelector('.gproperty-page__eyebrow');
      if (selectionEyebrow) selectionEyebrow.textContent = resultText.verifiedAddress;
    }
    if (clearSelection) clearSelection.textContent = resultText.chooseAnother;

    function syncAddressProgress(index) {
      const hint = root.querySelector('[data-gproperty-address-hint]');
      if (hint) {
        const locale = composerLocale(root);
        const hasSelection = index === 2;
        const prompts =
          locale === 'zh-Hans'
            ? ['输入地址，再选择相符的大厦。', '已选择地址，请核对后确认。']
            : locale.indexOf('zh') === 0
              ? ['輸入地址，再選擇相符的大廈。', '已選擇地址，請核對後確認。']
              : [
                  'Enter an address, then select the matching building.',
                  'Address selected. Review it before confirming.',
                ];
        hint.textContent = prompts[hasSelection ? 1 : 0];
        hint.setAttribute('data-address-step', hasSelection ? 'review' : 'search');
      }
      const steps = root.querySelectorAll('.gproperty-page__progress > li');

      steps.forEach(function (step, stepIndex) {
        const current = stepIndex === index;
        step.classList.toggle('is-current', current);

        if (current) {
          step.setAttribute('aria-current', 'step');
        } else {
          step.removeAttribute('aria-current');
        }
      });
    }

    function setAddressState(state) {
      root.setAttribute('data-address-state', state);
      if (review) review.setAttribute('data-address-state', state);

      syncAddressProgress(state === 'selected' || state === 'verified' ? 2 : 0);
    }

    function status(message, state) {
      if (!statusNode) return;
      statusNode.textContent = message || '';
      if (message && state) statusNode.setAttribute('data-state', state);
      else statusNode.removeAttribute('data-state');
    }

    function focusReview() {
      focusAddressWorkspace(root, false);
    }

    function syncQueryControls() {
      var term = gate.clean(query && query.value);

      if (clearQuery) {
        clearQuery.hidden = !term;
      }

      if (searchSubmit) {
        searchSubmit.disabled = term.length < 2;
      }
    }

    function syncIntentPresets() {
      var kind = primaryRouteKind(context.intent);
      all(root, '[data-gproperty-intent-preset]').forEach(function (button) {
        var value = gate.clean(button.getAttribute('data-gproperty-intent-preset'));
        var active =
          (kind === 'family' && value === 'family-fit') ||
          (kind === 'owner' && value === 'owner-fit') ||
          (kind === 'assets' && value === 'evidence-readiness');
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function replaceIntentInUrl(intent) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('source', context.source === 'glhk' ? 'glhk' : 'gproperty');
        url.searchParams.set('intent', intent);
        window.history.replaceState(
          { gpropertyIntent: intent },
          '',
          url.pathname + url.search + url.hash
        );
      } catch (_) {}
    }

    function resultOptions() {
      return results ? all(results, 'button[role="option"]') : [];
    }

    function markFocusedResult(button) {
      resultOptions().forEach(function (option) {
        option.setAttribute('aria-selected', option === button ? 'true' : 'false');
      });
    }

    function focusResultOption(index) {
      var options = resultOptions();
      if (!options.length) return false;
      var next = ((index % options.length) + options.length) % options.length;
      markFocusedResult(options[next]);
      options[next].focus();
      return true;
    }

    function clearResults() {
      if (!results) return;
      results.textContent = '';
      results.hidden = true;
      results.removeAttribute('data-state');
      results.removeAttribute('aria-busy');
      if (query) {
        query.setAttribute('aria-expanded', 'false');
        query.removeAttribute('aria-activedescendant');
      }
    }

    function renderResultState(kind, title, copy) {
      if (!results) return;
      clearResults();

      var row = document.createElement('div');
      row.className = 'gproperty-page__result-option';
      row.setAttribute('role', 'option');
      row.setAttribute('aria-disabled', 'true');
      row.setAttribute('data-gproperty-feedback-card', kind);

      var rank = document.createElement('span');
      rank.className = 'gproperty-page__result-rank';
      rank.setAttribute('aria-hidden', 'true');
      rank.textContent = kind === 'loading' ? '…' : kind === 'error' ? '!' : '0';

      var copyWrap = document.createElement('span');
      copyWrap.className = 'gproperty-page__result-copy';
      var strong = document.createElement('strong');
      var small = document.createElement('small');
      strong.textContent = title;
      small.textContent = copy;
      copyWrap.appendChild(strong);
      copyWrap.appendChild(small);

      row.appendChild(rank);
      row.appendChild(copyWrap);

      if (kind === 'error' || kind === 'empty') {
        var retry = document.createElement('button');
        retry.type = 'button';
        retry.className = 'gproperty-page__text-button';
        retry.setAttribute('data-gproperty-retry-search', '');
        retry.textContent = stateText.retry;
        retry.addEventListener('click', function () {
          if (query) query.focus();
          runSearch();
        });
        row.appendChild(retry);
      }

      results.appendChild(row);
      results.hidden = false;
      results.setAttribute('data-state', kind);
      results.setAttribute('aria-busy', kind === 'loading' ? 'true' : 'false');
      if (query) query.setAttribute('aria-expanded', 'true');
      status(title + ' ' + copy, kind === 'error' ? 'error' : 'info');
    }

    function clearSelected(focus) {
      selected = null;
      if (selection) selection.hidden = true;
      if (saveVerified) saveVerified.disabled = true;
      if (focus && query) query.focus();
    }

    function suspendActiveDraft() {
      activeDraft = null;
      if (savedPanel) savedPanel.hidden = true;
      configureRoutes(null);
      setAddressState('empty');
    }

    function clearQueryState() {
      window.clearTimeout(timer);
      requestSequence += 1;
      if (spinner) spinner.hidden = true;
      if (query) query.value = '';
      clearSelected(false);
      clearResults();
      suspendActiveDraft();
      status('');
      syncQueryControls();
      if (query) query.focus();
    }

    function sourceLabel() {
      return resultText.sourceVerified || resultText.sourceUnknown;
    }

    function renderSelection(estate) {
      if (!gate.isVerifiedEstate(estate)) {
        clearSelected(false);
        setAddressState('empty');
        renderResultState('error', resultText.unavailableTitle, resultText.unavailableCopy);
        return;
      }

      setText(
        root,
        '[data-gproperty-selection-name]',
        gate.locationLabel(estate) || resultText.verifiedAddress
      );
      setText(
        root,
        '[data-gproperty-selection-address]',
        estate.address_zh ||
          estate.address_en ||
          estate.geo_address ||
          resultText.addressUnavailable
      );

      var district = root.querySelector('[data-gproperty-selection-district]');
      var coordinate = root.querySelector('[data-gproperty-selection-coordinate]');
      var source =
        selection &&
        selection.querySelector(
          '.gproperty-page__selection-meta span:not([data-gproperty-selection-district]):not([data-gproperty-selection-coordinate])'
        );
      if (district) {
        district.textContent = estate.district_zh || estate.district_en || '';
        district.hidden = !district.textContent;
      }
      if (coordinate) {
        coordinate.textContent = estate.coordinate_verified
          ? resultText.coordinateVerified
          : resultText.coordinateUnavailable;
        coordinate.hidden = false;
      }
      if (source) {
        source.textContent = sourceLabel();
        source.removeAttribute('title');
      }

      if (selection) selection.hidden = false;
      if (saveVerified) saveVerified.disabled = false;
      setAddressState('selected');
      status(resultText.selectedStatus, 'success');

      try {
        window.dispatchEvent(
          new CustomEvent('littleg:gproperty:geocoded', {
            detail: { location: estate, context: context, source: RESULTS_CONTRACT },
          })
        );
      } catch (_) {}
    }

    function choose(item, body) {
      var normalized = gate.normalizeLocation(item, body);
      if (!gate.isVerifiedEstate(normalized)) {
        selected = null;
        setAddressState('empty');
        renderResultState('error', resultText.unavailableTitle, resultText.unavailableCopy);
        return;
      }
      selected = normalized;
      if (query) query.value = gate.locationLabel(selected);
      syncQueryControls();
      clearResults();
      renderSelection(selected);
    }

    function makeResultButton(item, body, index) {
      var button = document.createElement('button');
      var name = gate.clean(
        item.name_zh || item.name_en || item.formatted_address_zh || item.formatted_address_en
      );
      var address = gate.clean(
        item.formatted_address_zh || item.formatted_address_en || item.geo_address
      );
      var district = gate.clean(item.district_zh || item.district_en);
      var coordinate = item.coordinate_verified
        ? resultText.coordinateVerified
        : resultText.coordinateUnavailable;

      button.type = 'button';
      button.className = 'gproperty-page__result-option';
      button.id = (results && results.id ? results.id : 'gproperty-results') + '-option-' + index;
      button.tabIndex = -1;
      button.setAttribute('role', 'option');
      button.setAttribute('aria-selected', 'false');

      var rank = document.createElement('span');
      rank.className = 'gproperty-page__result-rank';
      rank.textContent = String(index + 1);

      var copy = document.createElement('span');
      copy.className = 'gproperty-page__result-copy';
      var strong = document.createElement('strong');
      var small = document.createElement('small');
      var meta = document.createElement('em');
      strong.textContent = name || resultText.verifiedAddress;
      small.textContent = address || resultText.addressUnavailable;
      meta.textContent = [district, coordinate, sourceLabel()].filter(Boolean).join(' · ');
      copy.appendChild(strong);
      copy.appendChild(small);
      copy.appendChild(meta);

      button.appendChild(rank);
      button.appendChild(copy);
      button.appendChild(makeResultArrowIcon());
      button.addEventListener('focus', function () {
        markFocusedResult(button);
      });
      button.addEventListener('click', function () {
        choose(item, body);
      });
      button.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          focusResultOption(index + 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          focusResultOption(index - 1);
        } else if (event.key === 'Home') {
          event.preventDefault();
          focusResultOption(0);
        } else if (event.key === 'End') {
          event.preventDefault();
          focusResultOption(resultOptions().length - 1);
        } else if (event.key === 'Escape') {
          event.preventDefault();
          clearResults();
          if (query) query.focus();
        }
      });
      return button;
    }

    function renderResults(body) {
      var rawItems = Array.isArray(body && body.results) ? body.results : [];
      var items = rawItems.filter(function (item) {
        return (
          typeof gate.isVerifiedAddressResult !== 'function' ||
          gate.isVerifiedAddressResult(item, body)
        );
      });
      var resolverCount = Number((body && body.resolver_result_count) || 0);
      var verifiedCount = Number((body && body.verified_address_result_count) || items.length);
      clearResults();

      if (!items.length) {
        if (resolverCount > 0 && verifiedCount === 0) {
          renderResultState('empty', resultText.fallbackTitle, resultText.fallbackCopy);
        } else {
          renderResultState('empty', resultText.emptyTitle, resultText.emptyCopy);
        }
        return;
      }

      items.slice(0, 5).forEach(function (item, index) {
        results.appendChild(makeResultButton(item, body, index));
      });
      results.hidden = false;
      results.setAttribute('data-state', 'ready');
      results.setAttribute('aria-busy', 'false');
      if (query) query.setAttribute('aria-expanded', 'true');
      syncAddressProgress(1);
      status(resultText.resultsFound(Math.min(items.length, 5)), 'info');
    }

    function runSearch() {
      var term = gate.clean(query && query.value);
      var sequence = ++requestSequence;
      window.clearTimeout(timer);
      clearSelected(false);
      clearResults();
      syncQueryControls();

      if (term.length < 2) {
        status(term ? stateText.shortQuery : '', term ? 'warning' : '');
        return;
      }

      if (spinner) spinner.hidden = false;
      renderResultState('loading', resultText.loadingTitle, resultText.loadingCopy);

      gate
        .searchLocations(root.getAttribute('data-location-search-endpoint'), term)
        .then(function (response) {
          if (sequence !== requestSequence) return;
          var body = response.body || {};
          if (body.location_provenance_contract !== gate.locationProvenanceContract) {
            throw new Error('location_provenance_contract_invalid');
          }
          if (response.http_status === 404 && body.error === 'no_verified_address_result') {
            renderResults(body);
            return;
          }
          if (
            !response.response_ok ||
            body.ok === false ||
            body.success === false ||
            body.mock_data_used === true
          ) {
            throw new Error(body.error || body.status || 'location_search_failed');
          }
          renderResults(body);
        })
        .catch(function (error) {
          if (sequence !== requestSequence) return;
          if (gate.safeError(error) === 'request_timeout') {
            renderResultState('error', resultText.timeoutTitle, resultText.timeoutCopy);
          } else {
            renderResultState('error', resultText.unavailableTitle, resultText.unavailableCopy);
          }
        })
        .finally(function () {
          if (sequence === requestSequence && spinner) spinner.hidden = true;
        });
    }

    function safeBaseRoute(kind, link) {
      var attrName = 'data-' + kind + '-url';
      var configured = gate.clean(root.getAttribute(attrName));
      var href = gate.clean(link && link.getAttribute('href'));
      return configured || href || '/pages/gproperty-assets';
    }

    function configureRoute(link, kind, draft, verified, primaryKind) {
      if (!link) return;

      var requiresVerifiedAndReady = kind === 'family' || kind === 'owner' || kind === 'school';
      var blockedReason = '';
      if (requiresVerifiedAndReady && !verified) blockedReason = 'verified-address-required';
      else if (requiresVerifiedAndReady && !servingReady) blockedReason = 'public-data-not-ready';

      var base = safeBaseRoute(kind, link);
      var url;

      try {
        url = new URL(base, window.location.origin);
      } catch (_) {
        return;
      }

      ['address', 'district', 'budget', 'school_net', 'lead_id', 'score', 'estate'].forEach(
        function (keyName) {
          url.searchParams.delete(keyName);
        }
      );

      url.searchParams.set('source', context.source === 'glhk' ? 'glhk' : 'gproperty');
      url.searchParams.set('intent', routeIntent(kind, context.intent));
      if (gate.opaque(draft && draft.record_id)) {
        url.searchParams.set('record_id', draft.record_id);
      } else {
        url.searchParams.delete('record_id');
      }

      link.href = url.pathname + url.search + url.hash;
      link.dataset.primary = kind === primaryKind ? 'true' : 'false';
      link.classList.toggle('is-primary', kind === primaryKind);

      if (blockedReason) {
        link.setAttribute('aria-disabled', 'true');
        link.setAttribute('tabindex', '-1');
        link.dataset.blockedReason = blockedReason;
      } else {
        link.removeAttribute('aria-disabled');
        link.removeAttribute('tabindex');
        delete link.dataset.blockedReason;
      }
    }

    function configureRoutes(draft) {
      var verified = gate.isVerifiedDraft(draft);
      var primaryKind = primaryRouteKind(context.intent);

      ['assets', 'family', 'owner', 'school'].forEach(function (kind) {
        all(root, '[data-gproperty-route-kind="' + kind + '"]').forEach(function (link) {
          configureRoute(link, kind, draft, verified, primaryKind);
        });
      });

      setText(
        root,
        '[data-gproperty-route-note]',
        verified
          ? servingReady
            ? stateText.routeReady
            : stateText.routeWaiting
          : stateText.routeDraft
      );
    }

    function applyIntentPreset(intent) {
      var nextIntent = normalizeParam(intent, ALLOWED_INTENTS, '');
      if (!nextIntent) return;
      context.intent = nextIntent;
      root.dataset.entryIntent = nextIntent;
      applyEntryCopy(root, context);
      syncIntentPresets();
      replaceIntentInUrl(nextIntent);
      configureRoutes(activeDraft);
      if (query) query.focus();
    }

    function renderSaved(draft, restored) {
      var verified = gate.isVerifiedDraft(draft);
      var location = verified ? gate.locationLabel(draft.estate_context) : draft.project_location;
      var savedCopy = verified ? stateText.savedVerifiedCopy : stateText.savedDraftCopy;
      activeDraft = draft;

      if (restored) savedCopy = stateText.restoredPrefix + savedCopy;
      setText(
        root,
        '[data-gproperty-saved-title]',
        verified ? stateText.savedVerifiedTitle : stateText.savedDraftTitle
      );
      setText(root, '[data-gproperty-saved-copy]', savedCopy);
      setText(
        root,
        '[data-gproperty-saved-verification]',
        verified ? stateText.verifiedLabel : stateText.draftLabel
      );
      setText(root, '[data-gproperty-saved-location]', location || '—');
      setText(root, '[data-gproperty-saved-record]', gate.opaque(draft.record_id) || '—');

      configureRoutes(draft);
      setAddressState(verified ? 'verified' : 'draft');

      if (savedPanel) {
        savedPanel.hidden = false;
        savedPanel.setAttribute('data-state', verified ? 'verified' : 'draft');
        savedPanel.setAttribute('data-local-draft-state', restored ? 'restored' : 'saved');
        try {
          savedPanel.focus({ preventScroll: true });
        } catch (_) {
          savedPanel.focus();
        }
        savedPanel.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'auto'
            : 'smooth',
          block: 'start',
        });
      }
    }

    function persist(verified) {
      var term = gate.clean(query && query.value);
      if (!term) {
        status(stateText.needQuery, 'warning');
        if (query) query.focus();
        return false;
      }
      if (verified && !selected) {
        status(stateText.needVerified, 'warning');
        return false;
      }

      var existingResult = gate.readPropertyDraft(key, legacyKey);
      var draft = gate.createPropertyDraft(
        term,
        verified ? selected : null,
        existingResult.draft,
        context
      );

      if (!gate.writePropertyDraft(key, draft)) {
        status(stateText.storageError, 'error');
        return false;
      }

      renderSaved(draft, false);
      status(verified ? stateText.savedVerifiedStatus : stateText.savedDraftStatus, 'success');
      return true;
    }

    function resetAddressContext() {
      window.clearTimeout(timer);
      requestSequence += 1;
      if (spinner) spinner.hidden = true;
      clearSelected(false);
      clearResults();
      activeDraft = null;
      if (savedPanel) savedPanel.hidden = true;
      if (query) query.value = '';
      syncQueryControls();
      configureRoutes(null);
      setAddressState('empty');
      status(stateText.resetStatus, 'info');
      if (query) query.focus();
    }

    /* Existing GP-03 entry owner */
    if (startReview) startReview.addEventListener('click', focusReview);

    if (query) {
      query.addEventListener('input', function () {
        var term = gate.clean(query.value);
        requestSequence += 1;
        if (spinner) spinner.hidden = true;
        clearResults();
        if (
          (selected && term !== gate.locationLabel(selected)) ||
          (activeDraft && term !== gate.clean(activeDraft.project_location))
        ) {
          clearSelected(false);
          suspendActiveDraft();
        }
        syncQueryControls();
        window.clearTimeout(timer);
        timer = window.setTimeout(runSearch, SEARCH_DELAY_MS);
      });
      query.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown') {
          if (focusResultOption(0)) event.preventDefault();
          return;
        }
        if (event.key === 'ArrowUp') {
          if (focusResultOption(resultOptions().length - 1)) event.preventDefault();
          return;
        }
        if (event.key === 'Escape') {
          clearResults();
          return;
        }
        if (event.key === 'Enter') {
          event.preventDefault();
          runSearch();
        }
      });
    }

    if (searchSubmit) searchSubmit.addEventListener('click', runSearch);
    if (clearQuery) clearQuery.addEventListener('click', clearQueryState);

    all(root, '[data-gproperty-demo-query]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!query) return;
        if (activeDraft) suspendActiveDraft();
        query.value = gate.clean(button.getAttribute('data-gproperty-demo-query'));
        syncQueryControls();
        runSearch();
        query.focus();
      });
    });

    all(root, '[data-gproperty-intent-preset]').forEach(function (button) {
      button.addEventListener('click', function () {
        applyIntentPreset(button.getAttribute('data-gproperty-intent-preset'));
      });
    });

    all(root, '[data-gproperty-route-kind]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var blockedReason = link.getAttribute('data-blocked-reason');
        if (link.getAttribute('aria-disabled') !== 'true') return;
        event.preventDefault();
        status(
          blockedReason === 'public-data-not-ready'
            ? stateText.blockedReadiness
            : stateText.blockedVerified,
          'warning'
        );
        focusReview();
      });
    });

    if (clearSelection) clearSelection.addEventListener('click', resetAddressContext);
    if (saveUnverified)
      saveUnverified.addEventListener('click', function () {
        persist(false);
      });
    if (form)
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        persist(true);
      });

    all(root, '[data-gproperty-tool-link]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (selected && gate.clean(query && query.value) === gate.locationLabel(selected)) {
          if (!persist(true)) event.preventDefault();
          return;
        }
        if (gate.clean(query && query.value)) {
          event.preventDefault();
          status(stateText.needVerified, 'warning');
          focusReview();
        }
      });
    });

    var stored = gate.readPropertyDraft(key, legacyKey);
    var existing = stored.draft;
    if (existing && existing.project_location && query) {
      query.value = existing.project_location;
      syncQueryControls();
      if (gate.isVerifiedDraft(existing)) {
        selected = gate.normalizeEstateContext(existing.estate_context);
        renderSelection(selected);
      }
      renderSaved(existing, true);
      if (stored.migrated) status(stateText.migratedStatus, 'info');
    } else {
      configureRoutes(null);
      syncQueryControls();
    }
    syncIntentPresets();

    gate
      .publicReadiness(root.getAttribute('data-readiness-endpoint'))
      .then(function (response) {
        var body = response.body || {};
        if (gate.isServingReady(body)) {
          servingReady = true;
          setReadiness(
            root,
            'ready',
            stateText.readyTitle,
            stateText.readyCopy,
            stateText.readyBadge
          );
        } else if (gate.isPublicRedacted(body)) {
          servingReady = false;
          setReadiness(
            root,
            'blocked',
            stateText.blockedTitle,
            stateText.blockedCopy,
            stateText.blockedBadge
          );
        } else if (
          typeof gate.isFailClosed === 'function' &&
          gate.isFailClosed(response.http_status, body)
        ) {
          servingReady = false;
          setReadiness(
            root,
            'blocked',
            stateText.unavailableTitle,
            stateText.unavailableCopy,
            stateText.unavailableBadge
          );
        } else {
          servingReady = false;
          setReadiness(
            root,
            'blocked',
            stateText.unavailableTitle,
            stateText.unavailableCopy,
            stateText.unavailableBadge
          );
        }

        root.dataset.servingReady = servingReady ? 'true' : 'false';
        configureRoutes(activeDraft);
      })
      .catch(function () {
        servingReady = false;
        root.dataset.servingReady = 'false';
        setReadiness(
          root,
          'blocked',
          stateText.unavailableTitle,
          stateText.unavailableCopy,
          stateText.unavailableBadge
        );
        configureRoutes(activeDraft);
      });
  }

  function boot(scope) {
    var target = scope || document;
    if (target.matches && target.matches(ROOT)) init(target);
    all(target, ROOT).forEach(init);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        boot(document);
      },
      { once: true }
    );
  } else {
    boot(document);
  }
})(window, document);
